import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PROMPT_LIBRARY } from "@/lib/prompts";
import { PromptList } from "@/components/PromptList";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { LayoutGrid } from "lucide-react";

export { PromptIcon } from "@/components/PromptList";

export const PromptDrawer = ({ pins = [], custom = [], onTogglePin, usage = {} }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const pick = (id) => {
    setOpen(false);
    navigate(`/chat?prompt=${id}`);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          data-testid="see-all-prompts-button"
          className="ms-auto inline-flex min-h-[44px] items-center gap-2 rounded-full border border-white/10 px-5 text-sm font-semibold text-ink-soft transition-colors hover:border-brand/50 hover:text-brand active:scale-95"
        >
          <LayoutGrid className="h-4 w-4" /> See all {PROMPT_LIBRARY.length + custom.length} prompts
        </button>
      </SheetTrigger>

      <SheetContent
        side="right"
        data-testid="prompt-drawer"
        className="w-full max-w-none overflow-y-auto border-white/10 bg-panel p-0 sm:max-w-xl"
      >
        <PromptList pins={pins} custom={custom} onTogglePin={onTogglePin} onPick={pick} usage={usage} />
      </SheetContent>
    </Sheet>
  );
};
